import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgChevronLeft = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M22.297 4.703 14 13l8.297 8.297a.961.961 0 0 1 .297.703c0 .27-.1.505-.297.703l-2.594 2.594a.961.961 0 0 1-.703.297.961.961 0 0 1-.703-.297L6.703 13.703A.961.961 0 0 1 6.406 13c0-.27.1-.505.297-.703L18.297.703A.961.961 0 0 1 19 .406c.27 0 .505.1.703.297l2.594 2.594a.961.961 0 0 1 .297.703c0 .27-.1.505-.297.703z" />
  </svg>
);
export default SvgChevronLeft;
